import ThemedBlock from 'components/atoms/ThemedBlock'
import i18n from 'utils/i18n'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import React, { useEffect, useState } from 'react'
import HelperString from 'utils/helper-string'
import _ from 'lodash'
import Translate from 'utils/translate'
import ManagementHeader from 'components/management/molecules/ManagementHeader'
import { View } from 'react-native'
import DraggableFlatList from 'react-native-draggable-flatlist'
import { constantsActive } from 'utils/constants/constants'
import ThemedDivider from 'components/atoms/ThemedDivider'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import { listArrow } from 'styles/list'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationManagementFloorPositions from 'graphql/mutations/management/MutationManagementFloorPositions'
import ObjectFloor from 'utils/objects/floor'
import { layoutStyles } from 'styles/layout'
import ListItem from 'components/atoms/ListItem'

const BuildingFloors = ({ building }) => {
	
	const navigation = useNavigation();
	
	const [ isDraggable, setIsDraggable ] = useState(false )
	const [ isSaving, setIsSaving ] = useState(false )
	
	const [ floors, setFloors ] = useState( ObjectFloor.order( _.get( building, 'floors', [] ) ) )
	const [ draggedFloors, setDraggedFloors ] = useState( [] )
	
	const [ searchValue, setSearchValue ] = useState('')
	
	// reloaad when more floors are added
	useEffect( () => {
		setFloors( ObjectFloor.order( _.get( building, 'floors', [] ) ) )
	}, [ _.size( _.get( building, 'floors', [] ) ) ] )
	
	const toggleDraggable = () => {
		setIsDraggable( !isDraggable )
	}
	
	const openFloor = ( item= {} ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_BUILDINGS_FLOOR, {
			buildingGuid: building.guid,
			floorGuid: item.guid
		});
	}
	
	const createFloor = () => {
		openFloor( {} );
	}
	
	const renderFloorItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ Translate.field( item, 'name' ) }
				title_add_active_tag={ true }
				item={ item }
				accessoryRight={ listArrow }
				onPress={ openFloor }
			/>
		)
	}
	
	const renderDraggableFloorItem = ( { item, index, drag, isActive } ) => {
		return (
			<ListItem
				title={ Translate.field( item, 'name' ) }
				title_add_active_tag={ true }
				item={ item }
				drag={ drag }
				dragIsActive={ isActive }
			/>
		)
	}
	
	const mutateFloorPositions = () => {
		const variables = {};
		variables['floor_positions'] = _.map( draggedFloors, (object, key) => {
			return (
				{
					floor_guid: object.guid,
					position: key
				}
			);
		})
		
		new GraphqlBuilder()
			.addQuery( 'mutation_floor_position', MutationManagementFloorPositions, variables )
			.setOnStart( () => {
				setIsSaving( true )
			})
			.setOnSuccess( result => {
				const newFloors = ObjectFloor.order(
					_.map( floors, (item) => {
						return _.merge( item, _.find( result.mutation_floor_position.floor_positions, { 'guid': item.guid } ) );
					})
				);
				
				setIsSaving( false )
				setIsDraggable( false )
				setDraggedFloors( [] )
				setFloors( newFloors )
			})
			.setOnError( result => {
				setIsSaving( false )
			})
			.execute()
	}
	
	const filters = _.size( searchValue ) > 2 ? [ { field: 'name', kind: 'contains', value: searchValue } ] : null;
	
	const header = (
		<ManagementHeader
			inputs={[
				{
					placeholder: i18n.t( 'management:pages.buildings.building.team.input_search'),
					onChangeText: _.debounce( setSearchValue, 400 )
				}
			]}
			dragButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.FLOORS ) ? {
				onPress: toggleDraggable,
				drag: isDraggable,
				save: mutateFloorPositions,
				isSaving: isSaving
			} : null}
			addButton={ HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.FLOORS ) ? { onPress: createFloor } : null }
		/>
	);
	
	return (
		<Choose>
			<When condition={ isDraggable }>
				<ThemedBlock
					header={ header }
					shadow>
					
					<View style={ layoutStyles.flexOne }>
						<DraggableFlatList
							data={ _.filter( !_.isEmpty( draggedFloors ) ? draggedFloors : floors, { active: constantsActive.YES } ) }
							renderItem={ renderDraggableFloorItem.bind( this ) }
							ItemSeparatorComponent={ ThemedDivider }
							keyExtractor={ (item, index) => {
								return HelperString.hash(`draggable-item`, item.guid);
							} }
							onDragEnd={({ data }) => {
								return setDraggedFloors(data);
							} }
						/>
					</View>
				</ThemedBlock>
			</When>
			<Otherwise>
				<ManagementGroupedThemeList
					header={ header }
					items={ floors }
					renderItem={ renderFloorItem.bind( this ) }
					groupByKey={ 'active' }
					filters={ filters }
					groupByValues={ [
						constantsActive.YES,
						constantsActive.NO
					] }
				/>
			</Otherwise>
		</Choose>
	);
}

export default BuildingFloors
